import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function Layout({ children, onSearch }) {
  return (
    <div className="d-flex" style={{ minHeight: '100vh' }}>
      {/* Sidebar */}
      <nav className="bg-dark text-white p-3" style={{ width: '220px' }}>
        <h4 className="mb-4">Admin</h4>
        <ul className="nav flex-column">
          <li className="nav-item mb-2">
            <Link className="nav-link text-white" to="/admin-v1">Domains V-1</Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link text-white" to="/admin">Domains</Link>
          </li>
        </ul>
      </nav>

      {/* Main Content */}
      <div className="flex-grow-1">
        {/* Header with search */}
        <nav className="navbar navbar-light bg-light px-4 shadow-sm">
          <form className="d-flex ms-auto" onSubmit={(e) => e.preventDefault()}>
            <input
              className="form-control"
              type="search"
              placeholder="Search domain..."
              onChange={(e) => onSearch?.(e.target.value)}
            />
          </form>
        </nav>

        <main className="p-4">
          {children}
        </main>
      </div>
    </div>
  );
}
